import React from 'react';
import PropTypes from 'prop-types';
import { IntlShape } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import TimeInput from '../../input/TimeInput';
import FormGroupPart from './FormGroupPart';
import TimeButtons from './TimeButtons';

import messages from '../registrationMessages';

const DurationFormGroup = ({ duration, onChange, disabled, intl, showValidation, max }) => (
  <div className="form-group">
    <FormGroupPart
      label={messages.Duration}
      invalid={showValidation && (!duration || duration <= 0)}
    >
      <TimeInput
        value={duration}
        id="DurationMinutes"
        disabled={disabled}
        onChange={onChange}
        max={max}
      />
    </FormGroupPart>
    <div className="col-sm-6">
      <TimeButtons value={duration} onChange={onChange} disabled={disabled} intl={intl} />
    </div>
  </div>
);
DurationFormGroup.propTypes = {
  duration: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  max: PropTypes.number,
  showValidation: PropTypes.bool,
  intl: intlShape.isRequired,
};
DurationFormGroup.defaultProps = {
  duration: 0,
  disabled: false,
  showValidation: false,
  max: undefined,
};
export default DurationFormGroup;
